// Import the functions you need from the SDKs you need
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { FirebaseApp } from "./init";

export const FirebaseAuth = getAuth(FirebaseApp);

export const GetCurrentUser = () => {
  return getAuth(FirebaseApp).currentUser;
};

export const SignOut = async () => {
  return await getAuth(FirebaseApp).signOut();
};

export const SendResetPasswordEmail = async (email) => {
  return await sendPasswordResetEmail(FirebaseAuth, email);
};